import React from 'react';
import './Menu.css';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export interface IMenuProps {
}

export interface IMenuState {
    activeKey: string;
    expanded: boolean;
}

export class Menu extends React.Component<IMenuProps, IMenuState> {
    constructor(props: IMenuProps) {
        super(props);
        this.state = {
            activeKey: "home",
            expanded: false
        };
    }

    public render() {
        const { activeKey } = this.state;

        const handleClick = (selected: string) => {
            this.setState({ activeKey: selected, expanded: false });
        }

        return (
            <div>
                <nav className="navbar navbar-expand-lg navbar-light">
                    <button
                        className="navbar-toggler"
                        type="button"
                        aria-controls="basic-navbar-nav"
                        aria-expanded={this.state.expanded}
                        aria-label="Toggle navigation"
                        onClick={() => this.setState(({ expanded }) => ({ expanded: !expanded }))}
                    >
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div
                        className={`navbar-collapse${this.state.expanded ? " show" : " collapse"}`}
                        id="basic-navbar-nav"
                    >
                        <Nav activeKey={activeKey} className="justify-content-center vk-navbar">

                            <Nav.Item className={(activeKey === "home") ? "active" : ""} >
                                <Nav.Link as={Link} onClick={() => handleClick("home")} to="/home">Home</Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link className={(activeKey === "videos") ? "active" : ""} onClick={() => handleClick("videos")} as={Link} to="/videos">Videos</Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link className={(activeKey === "photos") ? "active" : ""} onClick={() => handleClick("photos")} as={Link} to="/photos">Photos</Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link className={(activeKey === "service") ? "active" : ""} onClick={() => handleClick("service")} as={Link} to="/service">Service</Nav.Link>
                            </Nav.Item>

                            <Nav.Item >
                                <Nav.Link className={(activeKey === "contact") ? "active" : ""} onClick={() => handleClick("contact")} as={Link} to="/contact">Contact</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </nav>
            </div>
        );
    };

  public componentDidMount() {
        const firstPath = window.location.pathname.split('/')[1];
        if (firstPath !== null && firstPath !== "")
            this.setState({ activeKey: firstPath });
    };

}
